<template>
  <v-list-group active-class="primary white--text" link to="/task-manager">
    <template v-slot:activator>
      <v-list-item-icon class="mr-4">
        <v-icon>portrait</v-icon>
      </v-list-item-icon>
      <v-list-item-title>Công việc</v-list-item-title>
    </template>
    <v-list class="py-0">
      <v-list-item v-if="true" active-class="blue lighten-4 primary--text" class="px-0" link to="/task-new-manager">
        <v-list-item-action></v-list-item-action>
        <v-list-item-title>Quản lý công việc</v-list-item-title>
      </v-list-item>
    </v-list>

    <v-list class="py-0" v-if="role.type === 'manager'">
      <v-list-item v-if="true" active-class="blue lighten-4 primary--text" class="px-0" link to="/config-task-role">
        <v-list-item-action></v-list-item-action>
        <v-list-item-title>Phân quyền công việc</v-list-item-title>
      </v-list-item>
    </v-list>

    <!-- <v-list class="py-0">
      <v-list-item v-if="true" active-class="blue lighten-4 primary--text" class="px-0" link to="/task-report">
        <v-list-item-action></v-list-item-action>
        <v-list-item-title>Báo cáo công việc</v-list-item-title>
      </v-list-item>
    </v-list> -->
  </v-list-group>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters('auth', ['profile', 'role']),
  },
}
</script>